import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next'; // I18N
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo2.png'
const ServicePage = () => {
    const { t } = useTranslation(); // I18N
    return (
        <Fragment>
           <Navbar Logo={Logo} hclass={'wpo-site-header-s3'}  />
            <PageTitle pageTitle={t('pageTitles.services')} pagesub={t('pageTitles.servicesSub')} />
            <ServiceSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
